
import styled from "styled-components"
import NakliyeKopruUcretInput from "../../shared/input/nakliyeHesaplama/NakliyeKopruUcretInput"
import { useDispatch, useSelector } from "react-redux";
import useWindowDimensions from "../../../hooks/useWindowSize";
import { deleteCurrentBridgeItem } from "../../../features/nakliyeHesaplama/nakliyeHesaplamaSlice";


const Container = styled.div`
    width: ${({width}) => width};
    color: ${({theme}) => theme.mainTextColor};

    h4{
     font-size: 10px;
     font-weight: var(--font-weight-md);
     margin: 5px 0;
     
    }
    .list{
        display: flex;
        flex-direction: column;

        .list-item{
            display: flex;
            font-size: 12px;
            font-weight: var(--font-weight-lg);
            height: 35px;

            .list-item-content{
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: calc(100% - 40px);
                border-bottom: 1px solid ${({theme}) => theme.mainTextColor};
                
                .name{


                }

                .price{
                    
                }
            }

            .last{
                border-bottom: none;

            }
            .delete-btn{
                width: 40px;
                cursor: pointer;
                height: 100%;
            }

        }




    }

`
const BridgePriceList = () => {

    const dispatch = useDispatch()

    const {
        currentBridgeList,
      } = useSelector(state => state.nakliyeHesaplama)

    const {windowDimensions} = useWindowDimensions()
      
  return (
    <Container width={windowDimensions.width <= 1400 ? "100%" : "320px"}>
        <NakliyeKopruUcretInput labelText={"Köprü Ücreti"} name={"kopruUcreti"} inputWidth={"100%"}/>
        {
            currentBridgeList.length > 0 &&
            <h4>Eklenenler</h4>
        }
        <div className="list">
            {
                currentBridgeList.map((item, i) => (
                    <div className="list-item">
                        <div className={i+1 === currentBridgeList.length ? "list-item-content last" : "list-item-content"}>
                            <div className="name">
                                {item.kopruIsmi === "Osmangazi" && "Osmangazi Köprüsü "} 
                                {item.kopruIsmi === "Yavuzsultan" && "Yavuz Sultan Selim Köprüsü "}
                                {item.kopruIsmi === "1915" && "1915 Çanakkale Köprüsü "}
                                {item.kopruIsmi === "Fatih" && "Fatih Sultan Mehmet Köprüsü "}
                                {item.kopruIsmi === "15Temmuz" && "15 Temmuz Şehitler Köprüsü "}
                                ({item.aracSınıfı})
                            </div>
                            <div></div>
                            <div className="price">{item.ucret} TL</div>
                        </div>
                        <button className="delete-btn"onClick={() => dispatch(deleteCurrentBridgeItem(item))}>Sil</button>
                    </div>
                ))
            }
        </div>
    </Container>
  )
}

export default BridgePriceList